import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import DocumentHeadTags from 'components/document-head-tags'
import InlineLink from 'components/ui/inline-link'
import ModalDialog from 'components/ui/modal-dialog'

const link = `${DISCO_SITE}/downloads`
const title = 'Uploading in bulk?'

const GetBulkUploaderPage = () => {
  const navigate = useNavigate()

  return (
    <ModalDialog
      title={title}
      primaryAction={{
        caption: 'Get Bulk Uploader',
        onClick: () => {
          window.open(link, '_blank')
        },
      }}
      onCancel={() => navigate('/')}
    >
      <DocumentHeadTags title={title} />
      <p>
        If you’re uploading a lot of files regularly, we recommend using our{' '}
        <InlineLink target="_blank" rel="noopener noreferrer" to={link}>
          Bulk Uploader
        </InlineLink>{' '}
        desktop app for quicker and more reliable processing.
      </p>
    </ModalDialog>
  )
}

export default GetBulkUploaderPage
